document.addEventListener("DOMContentLoaded", () => {

  const hoseTypeField =
    document.querySelector('[name="properties[Hose Type]"]');

  const sizeField =
    document.querySelector('[name="properties[AN Size]"]');

  if (!hoseTypeField || !sizeField) return;

  const compatibility = {

    "Stainless Steel Braided Hose": [
      "4AN","6AN","8AN","10AN","12AN","16AN","20AN"
    ],

    "Black Nylon Covered Stainless Steel Braided Hose": [
      "4AN","6AN","8AN","10AN","12AN","16AN","20AN"
    ],

    "Rubber Lined Stainless Steel Braided Hose": [
      "4AN","6AN","8AN","10AN","12AN","16AN","20AN"
    ]

  };

  hoseTypeField.addEventListener("change", () => {

    const selected = hoseTypeField.value;

    [...sizeField.options].forEach(option => {

      if (
        compatibility[selected] &&
        compatibility[selected].includes(option.value)
      ) {

        option.disabled = false;

      } else {

        option.disabled = true;

      }

    });

  });

});

  document.addEventListener("DOMContentLoaded", () => {
  console.log("Hose Builder script loaded");
});